// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.light-theme-only {
  color-scheme: light !important; 
  background-color: #f1f1f1 !important;
}

/* This forces the background to stay white even when autocompleted */
.login-form input:-webkit-autofill,
.login-form input:-webkit-autofill:hover, 
.login-form input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
  -webkit-text-fill-color: #333 !important;
}

/* Global reset */
* {
  box-sizing: border-box;
}

body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  background-color: #f8fafc; /* Lighter, cleaner grey-blue tint */
}

/* Center container */
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

/* Login box */
.login-box {
  background: #ffffff;
  padding: 40px 30px; /* More breathing room */
  border-radius: 12px; /* Softer corners */
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05); /* Softer, modern shadow */
  width: 380px;
  text-align: center;
  border: 1px solid #e2e8f0; /* Subtle border for definition */
}

.login-box h1 {
  margin-bottom: 30px;
  font-size: 26px;
  font-weight: 700;
  color: #1e293b; /* Deep slate instead of heavy navy */
  letter-spacing: -0.5px;
}

/* Form spacing */
.login-form .form-group {
  margin-bottom: 24px;
  text-align: left;
}

/* Labels */
.login-form label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 14px;
  color: #64748b; /* Lighter slate for a modern look */
}

/* Inputs */
.login-form input {
  width: 100%;
  padding: 12px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  color: #1e293b;
  transition: all 0.2s ease; /* Smooth focus effect */
}

.login-form input:focus {
  outline: none;
  border-color: #3b82f6; /* Soft blue focus */
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Button */
.login-btn {
  width: 100%;
  padding: 14px;
  background-color: #2563eb; /* Vibrant, friendly blue */
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  margin-top: 10px;
  transition: background-color 0.2s;
}

.login-btn:hover {
  background-color: #1d4ed8;
}

/* Error text */
.error-text {
  color: #ef4444; /* Brighter, modern red */
  font-size: 14px;
  margin-top: 16px;
  font-weight: 500;
}

.password-wrapper {
  position: relative;
  width: 100%;
}

.password-wrapper input {
  padding-right: 2.8rem;
}

.toggle-password {
  position: absolute;
  top: 50%;
  right: 0.8rem;
  transform: translateY(-50%);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-size: 1.1rem;
  color: #94a3b8; /* Faded icon color */
  transition: color 0.2s;
}

.toggle-password:hover {
  color: #1e293b;
}

.login-form input {
  width: 100%;
  padding: 12px 14px;
  background-color: #ffffff !important; /* Force white background */
  color: #1e293b !important;            /* Force dark text */
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  transition: all 0.2s ease;
}

/* Ensure focus doesn't trigger a dark state */
.login-form input:focus {
  outline: none;
  background-color: #ffffff !important;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

`, "",{"version":3,"sources":["webpack://./src/components/LoginForm.css"],"names":[],"mappings":";AACA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA,qEAAqE;AACrE;;;EAGE,yDAAyD;EACzD,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,6DAA6D;EAC7D,yBAAyB,EAAE,oCAAoC;AACjE;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,kBAAkB,EAAE,wBAAwB;EAC5C,mBAAmB,EAAE,mBAAmB;EACxC,2CAA2C,EAAE,0BAA0B;EACvE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB,EAAE,iCAAiC;AAC9D;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,qCAAqC;EACrD,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc,EAAE,oCAAoC;AACtD;;AAEA,WAAW;AACX;EACE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB,EAAE,wBAAwB;AACrD;;AAEA;EACE,aAAa;EACb,qBAAqB,EAAE,oBAAoB;EAC3C,6CAA6C;AAC/C;;AAEA,WAAW;AACX;EACE,WAAW;EACX,aAAa;EACb,yBAAyB,EAAE,2BAA2B;EACtD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,cAAc,EAAE,yBAAyB;EACzC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc,EAAE,qBAAqB;EACrC,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oCAAoC,EAAE,2BAA2B;EACjE,yBAAyB,aAAa,oBAAoB;EAC1D,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,oCAAoC;EACpC,qBAAqB;EACrB,6CAA6C;AAC/C","sourcesContent":["\n.light-theme-only {\n  color-scheme: light !important; \n  background-color: #f1f1f1 !important;\n}\n\n/* This forces the background to stay white even when autocompleted */\n.login-form input:-webkit-autofill,\n.login-form input:-webkit-autofill:hover, \n.login-form input:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0px 1000px white inset !important;\n  -webkit-text-fill-color: #333 !important;\n}\n\n/* Global reset */\n* {\n  box-sizing: border-box;\n}\n\nbody, html {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  font-family: \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  background-color: #f8fafc; /* Lighter, cleaner grey-blue tint */\n}\n\n/* Center container */\n.login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n/* Login box */\n.login-box {\n  background: #ffffff;\n  padding: 40px 30px; /* More breathing room */\n  border-radius: 12px; /* Softer corners */\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05); /* Softer, modern shadow */\n  width: 380px;\n  text-align: center;\n  border: 1px solid #e2e8f0; /* Subtle border for definition */\n}\n\n.login-box h1 {\n  margin-bottom: 30px;\n  font-size: 26px;\n  font-weight: 700;\n  color: #1e293b; /* Deep slate instead of heavy navy */\n  letter-spacing: -0.5px;\n}\n\n/* Form spacing */\n.login-form .form-group {\n  margin-bottom: 24px;\n  text-align: left;\n}\n\n/* Labels */\n.login-form label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  font-size: 14px;\n  color: #64748b; /* Lighter slate for a modern look */\n}\n\n/* Inputs */\n.login-form input {\n  width: 100%;\n  padding: 12px 14px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  color: #1e293b;\n  transition: all 0.2s ease; /* Smooth focus effect */\n}\n\n.login-form input:focus {\n  outline: none;\n  border-color: #3b82f6; /* Soft blue focus */\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* Button */\n.login-btn {\n  width: 100%;\n  padding: 14px;\n  background-color: #2563eb; /* Vibrant, friendly blue */\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 600;\n  margin-top: 10px;\n  transition: background-color 0.2s;\n}\n\n.login-btn:hover {\n  background-color: #1d4ed8;\n}\n\n/* Error text */\n.error-text {\n  color: #ef4444; /* Brighter, modern red */\n  font-size: 14px;\n  margin-top: 16px;\n  font-weight: 500;\n}\n\n.password-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.password-wrapper input {\n  padding-right: 2.8rem;\n}\n\n.toggle-password {\n  position: absolute;\n  top: 50%;\n  right: 0.8rem;\n  transform: translateY(-50%);\n  cursor: pointer;\n  user-select: none;\n  font-size: 1.1rem;\n  color: #94a3b8; /* Faded icon color */\n  transition: color 0.2s;\n}\n\n.toggle-password:hover {\n  color: #1e293b;\n}\n\n.login-form input {\n  width: 100%;\n  padding: 12px 14px;\n  background-color: #ffffff !important; /* Force white background */\n  color: #1e293b !important;            /* Force dark text */\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  transition: all 0.2s ease;\n}\n\n/* Ensure focus doesn't trigger a dark state */\n.login-form input:focus {\n  outline: none;\n  background-color: #ffffff !important;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
